import "../styles/components/Error.css";

const Error = ({ message = "Something went wrong.", fullScreen = true }) => {
  return (
    <div
      className={`benoma-error d-flex justify-content-center align-items-center text-light ${
        fullScreen ? "benoma-error-fullscreen" : "py-5"
      }`}
      role="alert"
    >
      <div className="container text-center">
        <span className="error-label font-monospace text-danger d-block mb-3">ERROR</span>
        <h2 className="fw-bold mb-3">Something went wrong.</h2>
        <p className="text-secondary mb-0">{message}</p>
      </div>
    </div>
  );
};

export default Error;
